import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import {
  SocialReducer,
  UserReducer,
  ConfigurationReducer,
} from 'social-video-react-redux';

import newTooltip from 'reducers/NewTooltip';

import musicReducer from 'containers/MusicPage/reducer';
import navigation from 'containers/Header/reducer';
import profiles from 'containers/Profiles/reducers';
import headband from './headband';
import config from './response';
import checkLogin from './checkLogin';
import navReducer from './nav/reduce';
import metadata from './responseMetadata';
import asset from './responseAsset';
import user from './user';
import favorites from './favorites';
import translations from './translationReducer';
import planSelectorInfo from './planSelectorInfo';
import showModal from './showModal';
import card from './card';
import epg from './epg/epg';
import metrics from './metrics';
import webSocial from './social';
import carousel from './carousel';
import playAndGo from './playAndGo';
import general from './general';
import tooltip from './tooltip';
import specials from './specials';
import loginRedirect from './loginRedirect';
import ipTelmex from './ip_telmex';
import preferences from './preferences';
import login from './login';
import eventCardReducer from '../modules/EventCard/EventCardReducer';
import payments from './payments';
import payway from './payway';
import { reducer as cvDevices } from './device';
import resetPassword from './resetPassword';
import cvUserModify from './user/modify';
import cvPasswordModify from './user/password';
import cvControlPin from './user/controlPin';
import cvRentHistory from './payway/rentHistory';
import content from './content';
import Player from '../containers/Player/reducers';
import cvEpg from '../containers/EPG/reducers';
import cvNavData from '../containers/Menu/reducer';
import PinForm from '../containers/PinForm/reducer/pinForm.reducer';
import cvCMS from './../containers/CarouselsDisplay/redux/reducers';
import Vcard from '../containers/Vcard/reducers/vcard.reducer';
import preview from '../containers/Vcard/reducers/preview.reducer';
import search from '../containers/NewSearchPage/redux/reducers';
import searchResults from '../containers/NewSearchPage/redux/searchResultsReducer';
import Mundial from '../containers/MundialViews/redux/reducers';
import epgVersion from './epgVersion';
import epgMenu from './epgMenu';
import EpgLineUp from './epgLineUp';
import unLockVodContent from '../containers/Vcard/reducers/unLockVodContent.reducer';
import userSuspendedInfo from '../containers/UserSuspendedModal/redux/reducers/setUserInfor.reducer';
import { episodeContainer } from '../containers/EpisodeContainer/redux/episodeContent.reducer';
import { recordingsBar } from '../containers/CarouselsDisplay/components/ContentsCarouselContainer/components/ContainerRecordingBar/redux/recordingsBar.reducer';
import linealChannel from './linealChannel/reducer';
import { modalLandingCommercial } from './modalLandingCommercial/modalLandingCommercial.reducer';
import { profilesReducer } from '../containers/ProfileManager/redux/profile.reducer';
import menuAvatar from '../containers/MenuAvatar/reducer';

export default function createReducer(asyncReducers) {
  return combineReducers({
    // old reducers
    Player,
    Vcard,
    search,
    newTooltip,
    navigation,
    payments,
    payway,
    content,
    checkLogin,
    config,
    nav: navReducer,
    metadata,
    asset,
    headband,
    user,
    favorites,
    translations,
    social: SocialReducer.default,
    apiConfiguration: ConfigurationReducer.default,
    userInfo: UserReducer.default,
    card,
    resetPassword,
    modal: showModal,
    routing: routerReducer,
    epg,
    metrics,
    webSocial,
    carousel,
    playAndGo,
    general,
    tooltip,
    specials,
    loginRedirect,
    ipTelmex,
    preferences,
    login,
    eventCard: eventCardReducer,
    music: musicReducer,
    ...asyncReducers,
    profiles,

    cvEpg,
    cvNavData,
    // new reducers
    cvDevices,
    cvUserModify,
    cvPasswordModify,
    cvControlPin,
    cvRentHistory,
    PinForm,
    cvCMS,
    searchResults,
    preview,
    Mundial,
    epgVersion,
    epgMenu,
    EpgLineUp,
    unLockVodContent,
    userSuspendedInfo,
    episodeContainer,
    recordingsBar,
    linealChannel,
    planSelectorInfo,
    modalLandingCommercial,
    profilesManager: profilesReducer,
    menuAvatar,
  });
}
